module.exports = __webpack_public_path__ + "img/copy.a7a665c0.png";